export enum ToastType {
  None,
  ProfileDisplayInfoUpdated,
  ErrorSavingProfileDisplayInfo,
}
